import React from 'react'


const Banner = () => {
  return (
    <div className='relative z-50  h-[800px] lg:h-[950px]'>
      <div className='myBanner '>
        <img src="/img/header.png" alt="" />
      </div>
    </div>
  )
}

export default Banner